/*jshint esversion: 8 */
import React from 'react';
import {
  Route,
  Switch,
} from 'react-router-dom';
import PropTypes from 'prop-types';

/** material ui */
import { withStyles } from '@material-ui/core/styles';

import { observer } from 'mobx-react';
import { withRouter } from "react-router";

import HomeOAuth from '../pages/Home/HomeOAuth';

import MarketManagement from '../pages/SystemManagement/MarketManagement/MarketManagement';
import UserManagement from '../pages/SystemManagement/UserManagement/UserManagement';
import AuthorizationManagement from '../pages/SystemManagement/AuthorizationManagement/AuthorizationManagement';
import UserInfoManagement from '../pages/SystemManagement/UserInfoManagement/UserInfoManagement';

import TicketInfoManagement from '../pages/RoomTicketManagement/TicketInfoManagement/TicketInfoManagement';
import DeveloperManagement from '../pages/RoomTicketManagement/DeveloperManagement/DeveloperManagement';
import RoomManagement from '../pages/RoomTicketManagement/RoomManagement/RoomManagement';
import DeveloperUserManagement from '../pages/RoomTicketManagement/DeveloperUserManagement/DeveloperUserManagement';

import OrderManagement from '../pages/TradeManagement/TradeManagement/OrderManagement/OrderManagement';
import TradeStatistics from '../pages/TradeManagement/TradeManagement/TradeStatistics';

import ComfortableHousingTable from '../pages/ComfortableHousingMgmt/ComfortableHousingTable';
import Statistics from '../pages/ComfortableHousingMgmt/Statistics';


const styles = theme => ({});

class RouterContainerInner extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    return (
      <Switch>
        {/* 主页 */}
        <Route exact path="/" component={HomeOAuth} />

        {/* 用户管理 */}
        <Route path="/SystemManagement/marketManagement" component={MarketManagement} />
        <Route path="/SystemManagement/userManagement" component={UserManagement} />
        <Route path="/SystemManagement/authorizationManagement" component={AuthorizationManagement} />
        <Route path="/SystemManagement/userInfoManagement" component={UserInfoManagement} />
        {/* <Route path="/SystemManagement/appendixFlow" component={AppendixFlow} /> */}

        {/* 房票管理 */}
        <Route path="/RoomTicketManagement/TicketInfoManagement" component={TicketInfoManagement} />
        <Route path="/DeveloperManagement/DeveloperManagement" component={DeveloperManagement} />
        <Route path="/RoomManagement/RoomManagement" component={RoomManagement} />
        <Route path="/DeveloperUserManagement/DeveloperUserManagement" component={DeveloperUserManagement} />
        {/* <Route path="/RoomResources/RoomResources" component={RoomResources} /> */}

        {/* 安居房管理 */}
        {/* 安置房住户明细表 */}
        <Route path="/ComfortableHousingManagement/ComfortableHousingTable" component={ComfortableHousingTable} />
        {/* 安置房信息统计 */}
        <Route path="/ComfortableHousingManagement/Statistics" component={Statistics} />

        {/* 交易管理 */}
        <Route path="/TradeManagement/OrderManagement" component={OrderManagement} />
        <Route path="/TradeManagement/TradeStatistics" component={TradeStatistics} />
        <Route path="/*" component={HomeOAuth} />
      </Switch>
    );
  }
}


const RouterContainer = withRouter(observer(RouterContainerInner));

RouterContainer.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(RouterContainer);
